import Vue from 'vue'

// vant
import Vant from 'vant'
import Moment from 'moment'
import VConsole from 'vconsole'
import VueDraggableResizable from 'vue-draggable-resizable'

// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// plugins
import plugins from '@/plugins'
import 'amfe-flexible'
import App from './App.vue'
// mixins
import mixins from './mixins'
import '@/mixins/getImgUrl'

// router
import router from './router'
// store
import store from './store'
import background from './components/background.vue'

// styles
import './assets/reset.less'
import './style/index.less'
import 'vant/lib/index.less'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

// global js
import '@/global/WeChatInput'

if (process.env.VUE_APP_ENV !== 'production') {
  const vConsole = new VConsole()
}

// register element ui component
Vue.use(ElementUI)

Vue.use(plugins)
Vue.use(mixins)
Vue.use(Vant)
Vue.component('background', background)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.prototype.$checkPhone = telephone => /^1[3456789]\d{9}$/.test(telephone)
Vue.prototype.$jsonPase = jsonString => {
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    return {}
  }
}
Vue.filter('filterTime', value => {
  if (!value) return ''
  return Moment(value * 1000).format('YYYY-MM-DD')
})
Vue.prototype.$isWeiXin = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
    return true
  }
  return false
}

Vue.config.productionTip = false
Vue.prototype.$Bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
